import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
// import router from './router'

import VueRouter from 'vue-router';
import store from './store'
import { routes } from './router/routes';

Vue.config.productionTip = false


import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import VuePageTransition from 'vue-page-transition'
Vue.use(VuePageTransition)

import firebase from 'firebase/app';
import 'firebase/auth';          // for authentication
import 'firebase/firestore';     // for cloud firestore
import 'firebase/functions';     // for cloud functions

import './css/style.scss';


import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)

// import NProgress from 'nprogress';

// import * as bulmaToast from "bulma-toast";
// Vue.use(bulmaToast);


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import { 
  faHome,
  faChevronLeft,
  faChevronRight,
  faLifeRing,
  faVolumeUp
} from '@fortawesome/free-solid-svg-icons'

// import { 
//   faFrownO,
//   faMehO,
//   faSmileO
// } from '@fortawesome/fontawesome-free'

library.add(
	faHome,
  faChevronLeft,
  faChevronRight,
  faLifeRing,
  faVolumeUp
  // faFrownO,
  // faMehO,
  // faSmileO
)


Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueRouter);

const router = new VueRouter({
  routes: routes,
  mode: 'history'
});




// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (to.name == 'home') {
//     // console.log('to.meta: ',to.meta);
//     // next({meta: {transition: 'overlay-up-down'} , replace: true});
//     next();
//   } else {
//     // console.log('to: ',to);
//     next();
//   }
//   // next({meta: { transition: 'flip-x' }});

//   // console.log('Metaaa: ',to.meta);
//   // next();
  
// });



// Initialize Firebase
var firebaseConfig = {
    apiKey: "AIzaSyD_s3EQkbXyWPnl7h7sZyuCt-eXaV0f0l4",
    authDomain: "learn-offshoresms.firebaseapp.com",
    databaseURL: "https://learn-offshoresms.firebaseio.com",
    projectId: "learn-offshoresms",
    storageBucket: "learn-offshoresms.appspot.com",
    messagingSenderId: "253485643602",
    appId: "1:253485643602:web:f8423f5d4cc6248bd4ec8b",
    measurementId: "G-6VJYL853CK"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
// date issue fix according to firebase
export const settings = { 
    //timestampsInSnapshots: true, //deprecated
};
db.settings(settings);


db.enablePersistence({
  //experimentalTabSynchronization:true // deprecated
  synchronizeTabs: true
})
.then(() => {
   console.log("Woohoo!! Multi-Tab Persistence!");
})
.catch(function(err) {
    console.log('enablePersistence error:',err)
    if (err.code == 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled
        // in one tab at a a time.
        // ...
    } else if (err.code == 'unimplemented') {
        // The current browser does not support all of the
        // features required to enable persistence
        // ...
    }
});

// export const storage = firebase.storage();




Vue.component('tab', {
    template: `<transition :name="slideType"><div v-show="isActive"><slot></slot></div></transition>`,

    props: {
        name:{required: true},
        selected: { default: false}
    },

    data(){
        return{
            isActive: false,
            slideType: 'slide-right',
        }
    },

    created(){
        this.isActive = this.selected
    }
});



new Vue({ 
  el: '#app', 
  router, 
  store,
  render: h => h(App) 
})

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

// new Vue({
//   el: '#app',
//   store: store,
//   router: router,
//   render: h => h(App),
// });
